<div class="amount-container">
  <span class="amount-container__header">{{ heading }}</span>
  <app-accounts-dollar-parser
    [dollarAmount]="dollarAmount"
    [isDisplayingDecimalSeparator]="displayDecimalSeperator"
    [testId]="testId"
  ></app-accounts-dollar-parser>
  @if (!!subtitle) {
    <span class="amount-container__subtitle">{{
      subtitle
    }}</span>
  }
</div>
